module.exports = __webpack_public_path__ + "assets/certificate_pdf/OCPJP7_Oracle Certified Professional, Java SE 7 Programmer_219907858OCPJSE7.02f734e1.pdf";